import { TablePage } from "~/components/Table";
import { ApiKeyFilters } from "./components/ApiKeyFilters";
import {
  ApiKeySearchRequestProvider,
  ApiKeyTable,
} from "./components/ApiKeyTable";

export function ApiKeysPage() {
  return (
    <TablePage
      title="Search API Keys"
      RequestProvider={ApiKeySearchRequestProvider}
      table={<ApiKeyTable />}
      filters={<ApiKeyFilters />}
    />
  );
}
